module.exports = __webpack_public_path__ + "img/Registration_1.ae401286.jpg";